// Fallback menu used only if the server's /textile-navigation call fails.
// Kept identical to backend/config/textileCatalog.js so the mobile menu
// shows every category (it used to be an old men's-wear list, which hid
// Short Tops, Bottoms and Nightwears from the menu).
const leaf = (...values) =>
  values.reduce((tree, value) => ({ ...tree, [value]: null }), {});

const textileNavigation = {
  WOMEN: {
    Saree: {
      'Pattu Sarees': leaf(
        'Kanjivaram Pattu',
        'Arani Pattu',
        'Banarasi Pattu',
        'Venkatagiri Pattu',
        'Mangalagiri Pattu',
        'Narayanpet Pattu'
      ),
      'Cotton Sarees': leaf(
        'All-over Printed',
        'Plain Saree',
        'Stripes Saree',
        'Paisley Saree',
        'Elampillai Saree',
        'Pochampalli Saree',
        'Kalamkari Saree',
        'Chettinadu Saree'
      ),
      'Silk Sarees': leaf('Mysore Silk', 'Kanchipuram Silk', 'Dola Silk', 'Tussar Silk'),
      'Fancy Sarees': leaf(
        'Chiffon Saree',
        'Bomkai Saree',
        'Gadwal Saree',
        'Katan Saree',
        'Leheriya Saree',
        'Georgette Saree',
        'Patola Saree'
      ),
      '100% Polyester Sarees': leaf('Printed', 'Plain', 'Paisley Print', 'Stripes'),
      // NOTE: your screenshot was cropped right after "Stripes" for this row —
      // if there were more items below it, add them here.
      '100% Rayon / Viscose Sarees': leaf('Printed', 'Plain', 'Stripes')
    },
    Kurti: leaf('Cotton', 'Rayon', 'Printed', 'Embroidery'),
    'Churidar Set': leaf('Alia Cut', 'Churidar Set', 'Anarkali Set', 'Sharara Set', 'Gowns'),
    'Short Tops': leaf('Casual', 'Printed', 'Formal', 'Party Wear'),
    'T-Shirt': leaf('Round Neck', 'V Neck', 'Collar', 'Full Hand Sleeved'),
    Bottoms: leaf('Leggins', 'Elephant Pants', 'Palazzo', 'Skirt', 'Pants', 'Jeans'),
    Nightwears: leaf('Nighty', 'Night Suits', 'Pyjama Set', 'Short Sets'),

  },
  KIDS: {
    Boys: leaf('Shirt', 'T-Shirt', 'Jeans', 'Pant', 'Shorts', 'Track Pant', 'Hoodie', 'Innerwear'),
    Girls: leaf('Frock', 'Top', 'Leggings', 'Skirt', 'Jeans', 'T-Shirt', 'Gown', 'Innerwear'),
    Baby: leaf('Romper', 'Jabla', 'Night Suit', 'T-Shirt', 'Pant', 'Cap', 'Socks')
  }
};

export default textileNavigation;
